var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _updatePosition, _mutationObserver, _resizeListener;
import { Component } from "@theme/component";
import { debounce, requestIdleCallback, viewTransition } from "@theme/utilities";
const OFFSET = 40;
class FloatingPanelComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _updatePosition, async () => {
      if (viewTransition.current) await viewTransition.current;
      const rect = this.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      if (rect.right > viewportWidth) {
        const overflowAmount = rect.right - viewportWidth + OFFSET;
        this.style.left = `-${overflowAmount}px`;
      }
      if (rect.left < 0) {
        const overflowAmount = Math.abs(rect.left) + OFFSET;
        this.style.left = `${overflowAmount}px`;
      }
      __privateGet(this, _mutationObserver).takeRecords();
    });
    __privateAdd(this, _mutationObserver, new MutationObserver(__privateGet(this, _updatePosition)));
    __privateAdd(this, _resizeListener, debounce(() => {
      const parent = this.closest("details");
      const closeOnResize = this.dataset.closeOnResize === "true";
      if (parent instanceof HTMLDetailsElement && closeOnResize) {
        parent.open = false;
        parent.removeAttribute("open");
        __privateGet(this, _updatePosition).call(this);
      }
    }, 100));
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("resize", __privateGet(this, _resizeListener));
    requestIdleCallback(() => {
      __privateGet(this, _updatePosition).call(this);
      __privateGet(this, _mutationObserver).observe(this, { attributes: true });
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", __privateGet(this, _resizeListener));
    __privateGet(this, _mutationObserver).disconnect();
  }
}
_updatePosition = new WeakMap();
_mutationObserver = new WeakMap();
_resizeListener = new WeakMap();
if (!customElements.get("floating-panel-component")) {
  customElements.define("floating-panel-component", FloatingPanelComponent);
}
export {
  FloatingPanelComponent
};
